<section id="page-title">
  <div class="container">
    <ng-content></ng-content>
  </div>
</section>
